import React, { useState } from 'react'
import { MdArrowBack } from 'react-icons/md'
import { useUser } from '../../context/user'
import { checkTextStrength } from '../../utils/util'
import { useTranslation } from 'react-i18next'
import LoginWrapper from './LoginWrapper'
import { update_new_password } from '../../server/server'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { Oval } from 'react-loader-spinner'

function EnterNewPassword() {
    const [errorMessage, setErrorMessage] = useState('')
    const [password, setPassword] = useState('')
    const [retypedPassword, setRetypedPassword] = useState('')
    const { setUser } = useUser()
    const { t } = useTranslation()
    const history = useHistory()
    const location = useLocation()
    const { email, token } = location.state || {}
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (password === '' && retypedPassword === '') return
        if (password !== retypedPassword) {
            setErrorMessage(t('passwordsDoNotMatch'))
            setRetypedPassword('')
            setPassword('')
            return
        } else if (!checkTextStrength(password)) {
            setErrorMessage(t('passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol'))
            setRetypedPassword('')
            setPassword('')
            return
        }
        setLoading(true)
        const resp = await onNewPasswordSubmit(password)
        if (resp.status === 200) {
            const user = resp.data
            localStorage.setItem('userToken', user.token)
            localStorage.setItem('loginDate', Date.now())
            localStorage.setItem('user', JSON.stringify(user))
            setUser(user)
            setLoading(false)
        } else {
            const error = resp?.data?.message || resp.data
            setErrorMessage(error)
            setLoading(false)
        }
    }

    const onNewPasswordSubmit = async () => {
        try {
            const resp = await update_new_password({
                email,
                password,
                token,
            })
            return resp
        } catch (e) {
            return { data: 'Error', success: false }
        }
    }

    const handleBack = () => {
        setPassword('')
        setRetypedPassword('')
        history.push('/login')
    }
    return (
        <LoginWrapper>
            <div className="new-password-container">
                <div className="modal-title">
                    <p className="modal-title-main-text">
                        <span className="go-back-icon" onClick={handleBack}>
                            <MdArrowBack />
                        </span>
                        {t('newPassword')}
                    </p>
                </div>
                <div className="modal-subtitle" style={{ width: 'unset' }}>
                    <p>{t('passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol')}</p>
                </div>
                <div className="sign-up-section" style={{ marginTop: '15px' }}>
                    <div className="login-form">
                        <form onSubmit={handleSubmit}>
                            <div className="login-form-element-holder">
                                <input type="password" className="login-form-input" placeholder={t('password')} value={password} onChange={(e) => setPassword(e.target.value)} />
                            </div>
                            <div className="login-form-element-holder">
                                <input
                                    type="password"
                                    className="login-form-input"
                                    placeholder={t('repeatPassword')}
                                    value={retypedPassword}
                                    onChange={(e) => setRetypedPassword(e.target.value)}
                                />
                            </div>
                            <div className="error-message">{t(errorMessage)}</div>
                            <div className="login-form-element-holder mt-20">
                                <button className="auth-form-button">
                                    {loading ? <Oval strokeWidth={5} secondaryColor="#7ec5c6" color="#7ec5c6" height={30} width={30} /> : t('submitNewPassword')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </LoginWrapper>
    )
}

export default EnterNewPassword
